import React from "react";
import { Creatable } from "react-select";
import { mapToSelectOption, mapToSelectOptions, selectOnChangeWrapper } from "utils/select";
import styles from "./style.module.css";
const ColumnInput = ({ column, columns, onChange, isClearable, isDisabled, menuPlacement }) => {
    return (React.createElement("div", { className: styles.columnInput },
        React.createElement(Creatable, { value: mapToSelectOption(column), onChange: selectOnChangeWrapper(onChange), options: mapToSelectOptions(columns), placeholder: "Select Column", label: "Column", menuPlacement: menuPlacement ? menuPlacement : "bottom", isClearable: isClearable, isDisabled: isDisabled })));
};
export default ColumnInput;
